import { useContext, useState } from "react";
import { OrgIdContext } from "../../store/orgId_context";
import classes from "./addCustomerElements.module.scss";

const UserId = (props) => {
    const [copied,setCopied] =  useState();

    const { sessionInfo } =useContext(OrgIdContext);
    const onIdClick = () =>{
        navigator.clipboard.writeText(sessionInfo?.User?.Id);

        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    return(
        <div className={classes["orgIdText"]} {...props}>
            Your user Id is: 
            <span className={classes["orgId"]} onClick={onIdClick}>{sessionInfo?.User?.Id}</span>
            {copied && <span style={{paddingLeft:"1rem"}}>Copied!</span>}
        </div>
    )
}

export default UserId;